import React, { Component, PropTypes } from 'react';

import { Link } from 'react-router';
import { Dialog, FlatButton, RaisedButton } from 'material-ui';

import ChevronRightIcon from 'material-ui/svg-icons/navigation/chevron-right';
import ArrowBackIcon from 'material-ui/svg-icons/navigation/arrow-back';

class OnboardingModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      currentIndex: 0,
    };

    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.showOnboardingDialog !== nextProps.showOnboardingDialog) this.setState({ currentIndex: 0 });
  }

  handleModalClose = () => {
    this.props.handleModalClose();
  }

  nextSlide(e) {
    e.preventDefault();
    this.setState({ currentIndex: this.state.currentIndex + 1 });
  }

  prevSlide(e) {
    e.preventDefault();
    this.setState({ currentIndex: this.state.currentIndex - 1 });
  }

  render() {
    const {
      handleModalClose,
      lastSlideButton,
      onLastSlideButtonClick,
      showOnboardingDialog,
      slides,
      showSkipButton,
    } = this.props;

    const buttonText = this.state.currentIndex !== slides.length - 1 ? slides[this.state.currentIndex + 1].buttonText : lastSlideButton;
    const onSlideButtonClick = this.state.currentIndex !== slides.length - 1 ? this.nextSlide : onLastSlideButtonClick;

    const nextButton = (typeof onSlideButtonClick === 'string' ?
      <Link to={onSlideButtonClick}>
        <RaisedButton primary label={`${this.state.currentIndex !== 0 && this.state.currentIndex !== slides.length - 1 ? 'Next: ' : ''}${buttonText}`} labelPosition="before" icon={<ChevronRightIcon />} style={{ marginLeft: '10%', textAlign: 'right' }} />
      </Link>
      :
      <RaisedButton onClick={onSlideButtonClick} primary label={`${this.state.currentIndex !== 0 && this.state.currentIndex !== slides.length - 1 ? 'Next: ' : ''}${buttonText}`} labelPosition="before" icon={<ChevronRightIcon />} style={{ marginLeft: '10%', textAlign: 'right' }} />
    );

    return (
        <Dialog
          actions={
            <div style={{ backgroundColor: '#f3f3f3', padding: '10px', width: '100%' }}>
              <div style={{ display: 'inline-block', width: '70%', textAlign: 'left' }}>
                { this.state.currentIndex > 0 && <p style={{ display: 'inline-block', margin: '0 0 0 5%', padding: 0 }}><FlatButton onClick={this.prevSlide} icon={<ArrowBackIcon/>} style={{ color: '#00bcd4' }} label="back" /></p>}
                {nextButton}
              </div>
              <div style={{ display: 'inline-block', width: '30%' }}>
                { (showSkipButton || this.state.currentIndex !== slides.length - 1) && <a onTouchTap={handleModalClose} style={{ marginRight: '10%', cursor: 'pointer', textAlign: 'right' }}>Skip the tour</a> }
              </div>
            </div>
          }
          modal
          open={showOnboardingDialog}
          onRequestClose={this.handleModalClose}
          actionsContainerStyle={{ padding: 0 }}
          bodyStyle={{ minHeight: '350px' }}
          title={slides[this.state.currentIndex].header || null}
          titleStyle={{ backgroundColor: 'rgb(0, 188, 212)', color: 'rgb(255, 255, 255)', fontSize: '18px', marginBottom: '10px', padding: '1%', textAlign: 'center' }}
        >
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ fontWeight: 500, fontSize: '24px', margin: 0, padding: 0 }}>{slides[this.state.currentIndex].subHeader}</h2>
            {slides[this.state.currentIndex].content}
          </div>
        </Dialog>
    );
  }
}

OnboardingModal.propTypes = {
  handleModalClose: PropTypes.func,
  lastSlideButton: PropTypes.string,
  onLastSlideButtonClick: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  showOnboardingDialog: PropTypes.bool,
  showSkipButton: PropTypes.bool,
  slides: PropTypes.array,
};

export default OnboardingModal;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/onboardingModal.jsx